// Badge.tsx
import React from "react";
import { IoCloseOutline } from "react-icons/io5";
import { truncateText } from "../../utils/truncate";
import { textLength } from "../../utils/textSize";

interface ControlledBadgeProps {
  size?: "small" | "large";
  color?:
    | "gray"
    | "red"
    | "yellow"
    | "green"
    | "primary"
    | "grayPlus"
    | "yellow-gradient"
    | "purple"; // Add more colors as needed
  icon?: React.ReactElement;
  label: string;
  showRemoveButton?: boolean;
  onRemoveClick?: () => void;
  className?: any;
  doubleIcon?: boolean;
}

const getColorValues = (
  color:
    | "gray"
    | "red"
    | "yellow"
    | "green"
    | "primary"
    | "grayPlus"
    | "yellow-gradient"
    | "purple"
) => {
  switch (color) {
    case "grayPlus":
      return {
        bgColor: "bg-[#030712a6]",
        textColor: "text-[#FFF]",
        removeIconColor: "text-[#FFF]",
      };
    case "gray":
      return {
        bgColor: "bg-gray-100",
        textColor: "text-gray-900",
        removeIconColor: "text-gray-500",
      };
    case "red":
      return {
        bgColor: "bg-red-100",
        textColor: "text-red-800",
        removeIconColor: "text-red-500",
      };
    case "yellow":
      return {
        bgColor: "bg-yellow-100",
        textColor: "text-yellow-800",
        removeIconColor: "text-yellow-400",
      };

    case "yellow-gradient":
      return {
        bgColor: "test-gradient",
        textColor: "text-gray-900",
        removeIconColor: "text-yellow-400",
      };

    case "green":
      return {
        bgColor: "bg-green-100",
        textColor: "text-green-800",
        removeIconColor: "text-green-500",
      };
    case "primary":
      return {
        bgColor: "bg-primary-100",
        textColor: "text-primary-800",
        removeIconColor: "text-primary-500",
      };
    case "purple":
      return {
        bgColor: "bg-purple-100",
        textColor: "text-purple-800",
        removeIconColor: "text-primary-500",
      };

    default:
      return {
        bgColor: "",
        textColor: "",
        removeIconColor: "",
      };
  }
};

const ControlledBadge: React.FC<ControlledBadgeProps> = ({
  size = "small",
  color = "grayPlus",
  icon,
  label,
  showRemoveButton = false,
  className,
  onRemoveClick,
  doubleIcon,
}) => {
  const { bgColor, textColor, removeIconColor } = getColorValues(color);

  const labelNew = truncateText(label, 14);
  const textLength2 = textLength(label);

  const paddingSize =
    size === "small"
      ? "px-2"
      : icon || showRemoveButton
      ? "pl-2 pr-1"
      : "px-3 py-[2px]";

  return (
    <div
      className={` ${
        className ? className : " flex items-center rounded-md w-fit"
      } ${paddingSize} ${bgColor} ${textColor} m-1`}
    >
      {showRemoveButton && (
        <button
          onClick={onRemoveClick}
          className={`ml-1 ${removeIconColor} border-none cursor-pointer`}
        >
          <IoCloseOutline />
        </button>
      )}
      {icon && <div className={` ml-1 ${textColor}`}>{icon}</div>}
      <span className={`${textColor} px-[4px] py-[3px] `}>
        {/* {textLength2 > 25 ? labelNew : label} */}
        {<span className="">{label}</span>}
      </span>
      {icon && doubleIcon && <div className={` ml-1 ${textColor}`}>{icon}</div>}
    </div>
  );
};

export default ControlledBadge;
